import getComposerFocusSurface from '@/lib/getComposerFocusSurface.js';
import { THREAD_SURFACE_SIGNAL_KINDS, THREAD_SURFACE_SIGNAL_KIND_ASSISTANT_FIRST_VISIBLE_FRAME, THREAD_SURFACE_SIGNAL_KIND_ASSISTANT_REVEAL_DRAINED, THREAD_SURFACE_SIGNAL_KIND_EMPTY_STATE_EXIT_COMPLETE, THREAD_SURFACE_SIGNAL_KIND_JUMP_TO_BOTTOM_REACHED, THREAD_SURFACE_SIGNAL_KIND_NEW_THREAD_SHELL_MOUNTED, THREAD_SURFACE_SIGNAL_KIND_OPENING_HYDRATION_READY, THREAD_SURFACE_SIGNAL_KIND_OPENING_LAYOUT_MEASURED, THREAD_SURFACE_SIGNAL_KIND_OPENING_REVEAL_COMPLETE, THREAD_SURFACE_SIGNAL_KIND_OPENING_SCROLL_RESTORED, THREAD_SURFACE_SIGNAL_KIND_PERSISTED_THREAD_SHELL_READY, THREAD_SURFACE_SIGNAL_KIND_REQUEST_CREATE_THREAD, THREAD_SURFACE_SIGNAL_KIND_REQUEST_JUMP_TO_BOTTOM, THREAD_SURFACE_SIGNAL_KIND_REQUEST_NEW_THREAD, THREAD_SURFACE_SIGNAL_KIND_REQUEST_OPEN_THREAD, THREAD_SURFACE_SIGNAL_KIND_REQUEST_SUBMIT_TURN, THREAD_SURFACE_SIGNAL_KIND_SUBMITTED_TURN_SETTLED, THREAD_SURFACE_SIGNAL_KIND_TURN_ANCHOR_READY, THREAD_SURFACE_SIGNAL_KIND_USER_BUBBLE_REVEAL_COMPLETE, THREAD_SURFACE_SIGNAL_KIND_USER_RETURNED_NEAR_BOTTOM, THREAD_SURFACE_SIGNAL_KIND_USER_SCROLL_INTERRUPTED } from '@/lib/threadSurface/threadSurfaceSignalConstants.js';

const ROUTE_SIGNAL_KINDS = new Set([THREAD_SURFACE_SIGNAL_KIND_REQUEST_OPEN_THREAD, THREAD_SURFACE_SIGNAL_KIND_OPENING_HYDRATION_READY, THREAD_SURFACE_SIGNAL_KIND_OPENING_LAYOUT_MEASURED, THREAD_SURFACE_SIGNAL_KIND_OPENING_SCROLL_RESTORED, THREAD_SURFACE_SIGNAL_KIND_OPENING_REVEAL_COMPLETE]);

const THREAD_REQUIRED_SIGNAL_KINDS = new Set([THREAD_SURFACE_SIGNAL_KIND_REQUEST_OPEN_THREAD, THREAD_SURFACE_SIGNAL_KIND_REQUEST_SUBMIT_TURN, THREAD_SURFACE_SIGNAL_KIND_REQUEST_JUMP_TO_BOTTOM, THREAD_SURFACE_SIGNAL_KIND_PERSISTED_THREAD_SHELL_READY, THREAD_SURFACE_SIGNAL_KIND_OPENING_HYDRATION_READY, THREAD_SURFACE_SIGNAL_KIND_OPENING_LAYOUT_MEASURED, THREAD_SURFACE_SIGNAL_KIND_OPENING_SCROLL_RESTORED, THREAD_SURFACE_SIGNAL_KIND_OPENING_REVEAL_COMPLETE, THREAD_SURFACE_SIGNAL_KIND_USER_BUBBLE_REVEAL_COMPLETE, THREAD_SURFACE_SIGNAL_KIND_ASSISTANT_FIRST_VISIBLE_FRAME, THREAD_SURFACE_SIGNAL_KIND_ASSISTANT_REVEAL_DRAINED, THREAD_SURFACE_SIGNAL_KIND_SUBMITTED_TURN_SETTLED, THREAD_SURFACE_SIGNAL_KIND_USER_SCROLL_INTERRUPTED, THREAD_SURFACE_SIGNAL_KIND_JUMP_TO_BOTTOM_REACHED, THREAD_SURFACE_SIGNAL_KIND_USER_RETURNED_NEAR_BOTTOM]);

const SUBMISSION_REQUIRED_SIGNAL_KINDS = new Set([THREAD_SURFACE_SIGNAL_KIND_REQUEST_CREATE_THREAD, THREAD_SURFACE_SIGNAL_KIND_REQUEST_SUBMIT_TURN, THREAD_SURFACE_SIGNAL_KIND_EMPTY_STATE_EXIT_COMPLETE, THREAD_SURFACE_SIGNAL_KIND_PERSISTED_THREAD_SHELL_READY, THREAD_SURFACE_SIGNAL_KIND_ASSISTANT_FIRST_VISIBLE_FRAME, THREAD_SURFACE_SIGNAL_KIND_ASSISTANT_REVEAL_DRAINED, THREAD_SURFACE_SIGNAL_KIND_SUBMITTED_TURN_SETTLED]);

const SOURCE_SURFACE_REQUIRED_SIGNAL_KINDS = new Set([THREAD_SURFACE_SIGNAL_KIND_REQUEST_CREATE_THREAD, THREAD_SURFACE_SIGNAL_KIND_REQUEST_SUBMIT_TURN, THREAD_SURFACE_SIGNAL_KIND_EMPTY_STATE_EXIT_COMPLETE]);

const normalizeThreadSurfaceSignal = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return null;
  }

  const kind = String(payload?.kind || '').trim();
  const source = String(payload?.source || '').trim();
  const threadId = String(payload?.threadId || '').trim();
  const routeRequestId = Number(payload?.routeRequestId || 0);
  const submissionToken = String(payload?.submissionToken || '').trim();
  const sourceSurface = String(payload?.sourceSurface || '').trim() ? getComposerFocusSurface(payload?.sourceSurface) : '';

  if (!THREAD_SURFACE_SIGNAL_KINDS.includes(kind) || !source) {
    return null;
  }

  if (THREAD_REQUIRED_SIGNAL_KINDS.has(kind) && !threadId) {
    return null;
  }

  if (ROUTE_SIGNAL_KINDS.has(kind) && routeRequestId <= 0) {
    return null;
  }

  if (SUBMISSION_REQUIRED_SIGNAL_KINDS.has(kind) && !submissionToken) {
    return null;
  }

  if (SOURCE_SURFACE_REQUIRED_SIGNAL_KINDS.has(kind) && !sourceSurface) {
    return null;
  }

  if (kind === THREAD_SURFACE_SIGNAL_KIND_TURN_ANCHOR_READY && !submissionToken) {
    return null;
  }

  if (kind === THREAD_SURFACE_SIGNAL_KIND_USER_BUBBLE_REVEAL_COMPLETE && !submissionToken) {
    return null;
  }

  if (kind === THREAD_SURFACE_SIGNAL_KIND_REQUEST_NEW_THREAD || kind === THREAD_SURFACE_SIGNAL_KIND_NEW_THREAD_SHELL_MOUNTED) {
    return {
      kind,
      source
    };
  }

  return {
    kind,
    source,
    ...(threadId
      ? {
          threadId
        }
      : {}),
    ...(routeRequestId > 0
      ? {
          routeRequestId
        }
      : {}),
    ...(submissionToken
      ? {
          submissionToken
        }
      : {}),
    ...(sourceSurface
      ? {
          sourceSurface
        }
      : {})
  };
};

export default normalizeThreadSurfaceSignal;
